<template>
  <el-dialog class="k-foundation-edit-form" :title="foundation && foundation._id ? `Редактирвание фонда ${foundation._id}` : 'Добавление нового фонда'" :visible.sync="dialogFormVisible">
    <div class="k-foundation-edit-form__container">
      <p class="k-foundation-edit-form__title">Вы можете отредактирвать информацию о фонде. И сохранить ее в базе данных:</p>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Название фонда:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="title"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-promocode-edit-form__param">
        <el-col :span="8" class="k-promocode-edit-form__label">&nbsp;</el-col>
        <el-col :span="16"><el-checkbox v-model="active">Активний</el-checkbox></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Категории фонда:</el-col>
        <el-col :span="24">
          <el-transfer
            class="k-foundation-edit-form__categories"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="Найти категорию"
            :titles="['Не активные', 'Выбранные']"
            v-model="categories"
            :data="categoriesList"
          >
          </el-transfer>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Короткое описание фонда:</el-col>
        <el-col :span="16"><el-input placeholder="Короткое описание фонда" v-model="shortDescription" type="textarea" :rows="4"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Описание фонда:</el-col>
        <el-col :span="16"><el-input placeholder="Описание фонда" v-model="description" type="textarea" :rows="4"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Расчетный счет:</el-col>
        <el-col :span="16"><el-input placeholder="Расчетный счет" v-model="bankAccount" type="textarea" :rows="4"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">ID мерчанта:</el-col>
        <el-col :span="16"><el-input placeholder="Fondy merchant" v-model="merchantId"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Ключ оплати:</el-col>
        <el-col :span="16"><el-input placeholder="Fondy merchant" v-model="paymentKey"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Адрес:</el-col>
        <el-col :span="16"><el-input placeholder="Адрес" v-model="address"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">Веб сайт:</el-col>
        <el-col :span="16"><el-input placeholder="URL веб сайта" v-model="url"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-col :span="8" class="k-foundation-edit-form__label">URL логотипа:</el-col>
        <el-col :span="16"><el-input placeholder="URL логотипа" v-model="logoUrl"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-foundation-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini">Сохранить</el-button>
        <el-button round @click="handleCancel" size="mini">Отмена</el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
/**
 * Component: k-foundation-edit-form - Форма для редактирования информации о токене
*
* @version 1.0.0
*/

const toStr = param => param ? param : '';
const toBool = param => param ? param : true;

export default {
  name: 'k-foundation-edit-form',

  props: {
    // Является ли форма видимой
    dialogFormVisible: {
      type:Boolean,
      required: true,
    },

    // Данные для отображения
    foundation: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      title: '',
      active: false,
      description: '',
      shortDescription: '',
      bankAccount: '',
      merchantId: '',
      paymentKey: '',
      address: '',
      url: '',
      logoUrl: '',
      categories: [],
    };
  },

  computed: {
    categoriesList() {
      const data = [];
      this.foundationsCategories.forEach((category, index) => {
        data.push({
          label: category,
          key: index,
        });
      });
      return data;
    },

    ...mapGetters({
      foundationsCategories: 'settings/foundationsCategories',
    }),
  },

  watch: {
    foundation: {
      handler: function(newValue) {
        this.setFoundationData();
      },
      deep: true,
    },
  },

  async created() {
    await this.getAppSettings();
    if (this.foundation) {
      this.setFoundationData();
    }
  },

  methods: {
    setFoundationData() {
      this.title = this.foundation.title ? this.foundation.title : '';
      this.active = this.foundation.active ? this.foundation.active : false;
      this.description = this.foundation.description ? this.foundation.description : '';
      this.shortDescription = this.foundation.shortDescription ? this.foundation.shortDescription : '';
      this.bankAccount = this.foundation.bankAccount ? this.foundation.bankAccount : '';
      this.merchantId = this.foundation.merchantId ? this.foundation.merchantId : '';
      this.paymentKey = this.foundation.paymentKey ? this.foundation.paymentKey : '';
      this.address = this.foundation.address ? this.foundation.address : '';
      this.url = this.foundation.url ? this.foundation.url : '';
      this.logoUrl = this.foundation.logoUrl ? this.foundation.logoUrl : '';
      this.categories = this.foundation.categories ? this.foundation.categories.map(item => this.categoriesList.findIndex(category => category.label === item)) : [];
    },

    // Отмена редактирования токена
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение информации о токене на бекенде
    async handleSave() {
      const foundation = {
        title: this.title,
        active: this.active,
        description: this.description,
        shortDescription: this.shortDescription,
        address: this.address,
        bankAccount: this.bankAccount,
        merchantId: this.merchantId,
        paymentKey: this.paymentKey,
        url: this.url,
        logoUrl: this.logoUrl,
        categories: this.categories.map(item => this.categoriesList[item].label),
      };

      if (this.foundation._id) {
        foundation._id = this.foundation._id;
      }

      await this.setFoundation(foundation);
      this.$emit('update');
    },

    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },

    ...mapActions({
      getAppSettings: 'settings/getAppSettings',
      setFoundation: 'foundations/setFoundation',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-foundation-edit-form {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    margin-bottom: $vp;
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }

  &__icon {
    width: $icon-size;
    height: $icon-size;
    margin: 10px auto;
    border-radius: $icon-size / 2;
    background-color: black;

    & svg {
      width: $icon-size;
      height: $icon-size;
    }
  }
}
</style>
